import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { NewsletterBox } from "@/components/site/Newsletter";
import { useSocials } from "@/components/site/SocialLinks";
import { openPreferences } from "@/lib/consent";

const linkCls = "text-white/60 hover:text-vs-orange transition-colors text-sm";

// The "Termini e Condizioni" page lives at /pagina/{slug}; older footer data saved the
// bare slug (which 404s). Route it to the real admin/pagine page. Idempotent.
const normalizeLink = (link) =>
  link === "/termini-e-condizioni-d-uso" ? "/pagina/termini-e-condizioni-d-uso" : link;

export function Footer() {
  const [data, setData] = useState(null);
  const socials = useSocials();

  useEffect(() => {
    api.get("/settings/footer").then((r) => setData(r.data?.data || null)).catch(() => {});
  }, []);

  const columns = data?.columns || [];

  return (
    <footer className="bg-vs-text text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10">
        <div className="mb-16">
          <NewsletterBox source="footer" variant="peach" />
        </div>

        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="font-logo text-3xl text-vs-orange leading-none">Vagabondaggio Selvaggio</div>
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              {data?.description || "Aiuto a organizzare viaggi autentici, intelligenti e accessibili, in totale autonomia."}
            </p>
            <div className="flex gap-3 mt-5">
              {socials.map(({ key, label, url, Icon }) => (
                <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                   className="p-2.5 rounded-full bg-white/10 hover:bg-vs-orange transition-colors" aria-label={label} data-testid={`footer-social-${key}`}>
                  <Icon className="w-5 h-5" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => {
            const isLegal = (col.title || "").toLowerCase().includes("legal");
            const links = col.links || [];
            return (
              <div key={col.title}>
                <h4 className="font-extrabold text-white mb-4">{col.title}</h4>
                <ul className="space-y-2.5">
                  {links.map((l) => (
                    <li key={l.link}>
                      <Link to={normalizeLink(l.link)} className={linkCls}>{l.label}</Link>
                    </li>
                  ))}
                  {isLegal && (
                    <li>
                      <button type="button" onClick={openPreferences} className={`${linkCls} text-left`} data-testid="footer-cookie-preferences">
                        Preferenze cookie
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <span>{data?.copyright || "© 2026 Vagabondaggio Selvaggio."}</span>
          <Link to="/admin" className="hover:text-white/80 transition-colors" data-testid="admin-footer-link">Area riservata</Link>
        </div>
      </div>
    </footer>
  );
}
